<div class="viewer-container">

    <!-- Main Viewer -->
    <div class="viewer">
        <button class="nav-btn nav-left" (click)="prevPhoto()" [disabled]="photos.length <= 1">
            <mat-icon>chevron_left</mat-icon>
        </button>

        <img [src]="currentPhoto" [style.transform]="'scale(' + zoomLevel + ')'" class="photo" (wheel)="onWheel($event)"
            alt="Photo viewer" />

        <button class="nav-btn nav-right" (click)="nextPhoto()" [disabled]="photos.length <= 1">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>

    <!-- Toolbar -->
    <div class="toolbar">
        <button mat-icon-button (click)="zoomOut()" matTooltip="Zoom Out">
            <mat-icon>zoom_out</mat-icon>
        </button>

        <button mat-icon-button (click)="zoomIn()" matTooltip="Zoom In">
            <mat-icon>zoom_in</mat-icon>
        </button>

        <button mat-icon-button (click)="download()" matTooltip="Download">
            <mat-icon>download</mat-icon>
        </button>

        <span class="counter">{{ counter }}</span>

        <button mat-icon-button (click)="close()" matTooltip="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>